//  简体中文
export default {
    // 官网首页
    language: '语言',
    Data_terminal_products: '数据终端',
    industrial_product: '工业产品',
    mobile_terminal: '移动终端',
    contact_us: '联系我们',
    Project_customization: '项目定制',
    recruitment_information: '招聘信息',
    Technology_team: '技术&团队',
    Search: '搜索',
    Please_enter_keywords: '请输入关键字!',
    No_such_search_term: '无该搜索项，请输入其他关键字试试！',
    product: '产  品',
    four_industrial_gateway: '4G工业网关',
    five_industrial_gateway: '5G工业网关',
    modular: '模块类',
    MTK: 'MTK 平台',
    high_pass: '高通',
    Rock_Chip: 'Rock Chip',
    company: '公司简介',
    company_title: '深圳米饭儿数据科技有限公司',
    p1: '深圳米饭儿数据科技有限公司是一家创新型科技公司，成立于2007年。并且在2013年初，公司大力引进行业人才在深圳科技园成立研发总部,' +
        '米饭数据与北京邮电大学联合成立移动互联研发中心，并且购买高通License与其达成战略合作关系，购置4Rohde&Schwarz CMW500综测用于研发生产。',
    p2: '公司主要从事5G CPE、5G MiFi、5G USB网卡、5G模块、5G工业路由器，4G LTE 无线路由器(MIFI)、4G LTE 数据卡、通信模块、客户终端设备(CPE)等方案软硬件以及整机的研发工作。致力于数据通信终端客户' +
        '需求定制及行业特殊定制产品的设计，从终端到无线互联网络系统方案的无缝连接。到目前为止，我们的产品已覆盖100多个国家和世界各地的一些著名的国外运营商提供OEM / ODM服务。' +
        '公司产品全部自主研发设计，可针对客户需求进行更改和定制，拥有一流自主研发团队和知识产权全方位帮助客户整理项目实施方案。售前有研发部人员了解客户需求，' +
        '以减少中间沟通环节以节约时间。整个项目进程将有专业技术人员跟进完成。米饭数据将始终坚持“创新，品质，服务，认真，负责，感恩”12字理念。吸收新创意，严把质量关口，' +
        '全方位的跟踪服务，坚持做出高品质产品。 我们将本着“品质至上”的经营宗旨，不断创新。为全部客户提供优质的通信产品和完善的技术解决方案服务。' +
        '米饭数据将紧跟市场趋势，逐步走向国际市场的不断创新和改进产品技术，目标是成为一个世界顶级的4G数据终端的OEM / ODM设计师和制造商。',
    characteristic: '特色产品',
    Hot_selling_series: '热销系列',
    LC111: '4G路由器：4个网口，双天线WIFI',
    T115: '4G便携式热点：大容量锂电池供电，APN可配',
    LDW931: '4G USB网卡，内置WIFI',
    GC111: '4G工业网关：4个网口，双天线WIFI，支持三菱，发那科，西门子等CNC，PLC数据采集',
    M55: '5G工业网关：5口千兆网口，双频WIFI，RS232+RS485，支持MQTT和二次开发',
    D21: '4G智能终端：安卓系统，2.7寸屏，支持硬件加密，65W快充，8000mAh聚合物电池',
    Front_desk_switchboard: '前台总机:',
    Pre_sales_consultation: '售前咨询:',
    Contact_customer_service: '联系客服:',
    About_rice: '关于米饭儿',
    Company_qualification: '公司资质',
    Cooperative_partner: '合作伙伴',
    Industrial_gateway: '工业网关',
    Wechat_public_platform: '微信公众平台',
    Electronic_instruction_manual: '电子说明书',
    Human_customer_service: '人工客服',
    Rice: '©2021 深圳米饭儿数据科技有限公司',
    Yue_Hao: '粤ICP备18130408号-1',
    Rhinoceros_cloud: '犀牛云提供企业云服务',
    shop: '软件商城',
    Recruitment_information: '招聘信息',

    // 公司资质
    Enterprise_qualification: '企业资质',
    certificate_p1: '米饭儿营业执照',
    certificate_p2: '米饭儿logo商标注册',
    certificate_p3: '万唐商标注册',
    certificate_p4: '牛喵商标注册',
    certificate_p5: '进网许可证',
    certificate_p6: '牛喵logo商标注册',
    certificate_p7: '多功能鼠标专利',
    certificate_p8: '普利盟3C证书',
    certificate_p9: '电子设备专利',

    // 合作伙伴
    cooperative_partner: '合作伙伴',
    high_pass_span: '高通',
    high_pass_p: 'Qualcomm（高通公司）是全球领先的无线科技创新者，也是5G研发、商用与实现规模化的推动力量。我们致力于发明突破性的基础科技。' +
        '变革了世界连接、计算和沟通的方式。把手机连接到互联网，Qualcomm的发明开启了移动互联时代。今天，Qualcomm的基础科技赋能了整个移动生态系统，' +
        '每一台3G、4G和5G智能手机中都有其发明。Qualcomm将移动技术的优势带到汽车、物联网、计算等全新行业，开创人与万物能够顺畅沟通和互动的全新世界。' +
        '我们发明的基础科技，通过技术许可模式将发明成果与整个移动行业广泛分享，成为客户和合作伙伴创新、竞争以及在全球发展的强大后盾。这个模式起始于 1995 年，' +
        '是 Qualcomm 的核心使命、价值和文化的根基，推动着市场的蓬勃发展，并且让消费者持续受益。我们在全球致力于变革各行各业，这包括手机、汽车、移动计算、' +
        '网络设备和物联网行业，并且以超越想象的方式让数百万终端互联，最终丰富人类生活。',
    millet_span: '小米',
    millet_p: '小米科技有限责任公司成立于2010年3月3日[1]，是一家专注于智能硬件和电子产品研发的全球化移动互联网企业[2]，同时也是一家专注于高端智能手机、' +
        '互联网电视及智能家居生态链建设的创新型科技企业。[3]小米公司创造了用互联网模式开发手机操作系统、发烧友参与开发改进的模式。“为发烧而生”是小米的产品概念。' +
        '“让每个人都能享受科技的乐趣”是小米公司的愿景。小米公司应用了互联网开发模式开发产品，用极客精神做产品，用互联网模式干掉中间环节，致力让全球每个人，' +
        '都能享用来自中国的优质科技产品[3]。小米已经建成了全球最大消费类IoT物联网平台，连接超过1亿台智能设备[5]，MIUI月活跃用户达到2.42亿[6]。小米系投资的公司接近400家，' +
        '覆盖智能硬件、生活消费用品、教育、游戏、社交网络、文化娱乐、医疗健康、汽车交通、金融等领域。',
    Baidu_span: '百度',
    Baidu_p: '百度是拥有强大互联网基础的领先AI公司。百度愿景是：成为最懂用户，并能帮助人们成长的全球顶级高科技公司。“百度”二字，来自于八百年前南宋词人辛弃疾的一句词：' +
        '众里寻他千百度。这句话描述了词人对理想的执着追求。1999年底，身在美国硅谷的李彦宏看到了中国互联网及中文搜索引擎服务的巨大发展潜力，抱着技术改变世界的梦想，' +
        '他毅然辞掉硅谷的高薪工作，携搜索引擎专利技术，于 2000年1月1日在中关村创建了百度公司。百度拥有数万名研发工程师，这是中国乃至全球都顶尖的技术团队。' +
        '这支队伍掌握着世界上最为先进的搜索引擎技术，使百度成为中国掌握世界尖端科学核心技术的中国高科技企业，也使中国成为美国、俄罗斯、和韩国之外，全球仅有的4个拥有搜索引擎核心技术的国家之一。',
    Solid_height_span: '东莞固高自动化技术有限公司',
    Solid_height_p: '固高科技始创于1999年，是中国及亚太地区首家拥有自主知识产权的专注于运动控制及其自动化核心技术研究与开发的高科技企业，是国内外智能仪器设备领域的重要领导企业之一。' +
        '固高的创立者为自动化和微电子领域的国际知名专家、学者，具有多年在加州大学、麻省理工学院、贝尔实验室等国际一流科研机构进行研发和管理经验。固高科技汇集了大批在运动控制、' +
        '自动化及机电一体化等领域有独特建树的科技精英，致力于运动控制技术、图像与视觉传感技术、机械优化设计技术、伺服驱动技术相关产品的研发和应用。固高科技所遵循的理念是：' +
        '在运动控制领域要培养一流的运动控制技术人才；提供优良的运动控制产品和技术服务；帮助装备制造业的客户成为成功的企业。在“以市场为导向，以高新技术为立足点”的方针的指引下，' +
        '我们将继续坚持“以人为本, 把握良机”，迎接新的挑战，为客户提供一流的运动控制及其自动化产品、系统集成技术、整体解决方案和快速专业的技术服务，帮助客户提高核心竞争力，走向成功。',
    China_Unicom_span: '中国联通',
    China_Unicom_p: '中国联合网络通信集团有限公司（英文名称China Unicom、简称“中国联通”、“联通”）于2009年1月6日在原中国网通和原中国联通的基础上合并组建而成，' +
        '在国内31个省（自治区、直辖市）和境外多个国家和地区设有分支机构，是中国唯一一家在纽约、香港、上海三地同时上市的电信运营企业，连续多年入选“世界500强企业”。中国联通主要经营GSM、' +
        'WCDMA和FDD-LTE制式移动网络业务，固定通信业务，国内、国际通信设施服务业务，卫星国际专线业务、数据通信业务、网络接入业务和各类电信增值业务，' +
        '与通信信息业务相关的系统集成业务等。2009年1月6日，原中国联合通信有限公司与原中国网络通信集团公司重组合并，新公司更名为中国联合网络通信集团有限公司。' +
        '为与合并前的中国联通相区分，业界常以“新联通”进行称呼。',
    China_Telecom_span: '中国电信',
    China_Telecom_p: '中国电信集团有限公司，简称“中国电信”或“中国电信公司”。中国电信成立于1995年4月27日，是中国特大型国有通信企业、上海世博会全球合作伙伴，' +
        '连续多年入选"世界500强企业"，主要经营固定电话、移动通信、卫星通信、互联网接入及应用等综合信息服务。截至2019年12月，拥有固定电话用户1.10亿户，移动电话用户3.35亿户，' +
        '宽带用户 1.5亿户，集团公司总资产7109.64亿元，员工总数40余万人。2019年6月6日，工信部正式向中国电信发放5G商用牌照。 [2]  2020年12月18日，中国电信与中国传媒大学在北京签署战略合作框架协议，' +
        '携手推进5G智能媒体应用、传播产业发展。同时，双方还发挥各自资源优势，共同成立了“5G智能媒体传播与产业研究院”。中国电信与中国传媒大学的战略合作，是务实推进新基建、' +
        '数字中国和“媒体融合”等国家战略的重要举措。中国电信旗下号百控股公司，与中国传媒大学签署业务合作协议，推进具体合作项目落地。',

    // CPE-LC111
    Product_information: '产品信息',
    lc111_p1: 'LC111是一款CAT4等级的4G全网通CPE，插电即可实现有线和WIFI上网；APN可选，支持MQTT协议，集成云平台管理、流量限速、网络诊断工具（Ping、Traceroute）等功能； 符合3GPP Release 9、LTE 4G、3G标准。',
    Parameter_specification: '参数规格',
    img: '图片',
    model: '型号',
    Interface: '接口',
    size: '尺寸(mm)',
    Introduction_features: '简介特征',
    lc111_Interface_p1: '网口：1WAN+3LAN',
    lc111_Interface_p2: 'WIFI：双天线',
    lc111_p_word: '模块化设计，4G全网通，CAT4等级，支持APN+VPN接入，云平台管理',
    Detailed_illustration: '详细图解',

    // T115
    t115_p1: 'T115是一款CAT4等级的便携式无线路由器，支持全网通；APN可选，支持MQTT协议，集成云平台管理、流量限速功能；集成网络诊断工具如：Ping、Traceroute等.',
    t115_Interface_p1: 'WIFI：天线内置',
    t115_p_word: '电池容量1800mAh，4G全网通，CAT4等级，支持APN+VPN接入，云平台管理',

    // LDW931
    ldw931_p1: 'LDW931是一款CAT4等级的USB上网卡，支持全网通；APN可选，支持MQTT协议，集成云平台管理、流量限速功能；集成网络诊断工具如：Ping、Traceroute等.',
    ldw931_Interface_p1: 'WIFI：天线内置',
    ldw931_p_word: 'USB接口，支持Windows、Linux、安卓系统，4G全网通，CAT4等级，支持APN+VPN接入，云平台管理',

    // GC111
    gc111_p1: 'GC111是一款全网通CAT4级的工业网关，工业级设计，支持串口透传；支持MQTT协议，AT指令，APN+VPN接入；可广泛应用在智慧工厂、无人零售、森林防火等领域；接口丰富，软件扩展性强，支持二次开发和定制.',
    gc111_Interface_p1: '网口：1WAN+3LAN',
    gc111_Interface_p2: '串口：RS232+RS485',
    gc111_Interface_p3: 'WIFI：双天线',
    gc111_p_word: '工业等级，4G全网通，CAT4标准，支持APN+VPN接入，云平台管理，支持串口透传',

    // T300
    t300_p1: 'T300是一款4G工业级网关，采用模块化设计，运行OpenWrt Linux操作系统；具备多重硬件防护，即使在严苛环境下也能稳定运行；可广泛应用在智慧工厂、无人零售、森林防火等领域；接口丰富，软件扩展性强，支持二次开发和定制.',
    t300_Interface_p1: '网口：1WAN+4LAN',
    t300_Interface_p2: '串口：RS232+RS485',
    t300_Interface_p3: '8位DI，DO',
    t300_p_word: 'CAT4等级，全网通，工业级设计，支持串口透传，MQTT协议，APN+VPN接入，支持云平台管理',

    // M55
    m55_p1: 'M55是一款5G工业级网关，支持NSA和SA双模，向下兼容 4G/3G网络制式；具备多重硬件防护，即使在严苛环境下也能稳定运行；2.4GHz与5.8GHz双频WiFi，' +
        '可广泛应用在物联网M2M行业，为智慧工厂、高清直播、自动驾驶、远程医疗等领域提供高速率、低时延、广覆盖的传输网络.',
    m55_Interface_p1: '网口：1WAN+4LAN，全千兆',
    m55_Interface_p2: 'WIFI：双频，支持802.11AC标准',
    m55_Interface_p3: '串口：RS232+RS485',
    m55_p_word: '支持NSA和SA 5G双模，工业级设计，支持串口透传，MQTT协议，APN+VPN接入，支持云平台管理',

    // LM321
    lm321_p1: 'LM321是一款LGA封装的4G模块，CAT4标准，支持全网通，接口丰富；' +
        'APN可配置，支持MQTT协议，集成云平台管理、流量限速功能；集成网络诊断工具如：Ping、Traceroute等。',
    lm321_Interface_p1: '双串口，I2C，SPI',
    lm321_Interface_p2: '双ADC，20位DI',
    lm321_Interface_p3: 'DO，USB2.0，RMII',
    lm321_p_word: 'CAT4等级，全网通，工业级设计，支持串口透传，MQTT协议，APN+VPN接入，支持云平台管理',

    // D21
    d21_p1: 'D21是一款定制型便携式终端，CAT6标准全网通，8核1.8GHZ主频，运行安卓操作系统；内置了加密芯片和算法，让语音、数据隐秘传输，支持蓝牙接听和拨打电话.',
    d21_Interface_p1: 'WIFI：天线内置',
    d21_Interface_p2: '蓝牙5.1',
    d21_p_word: '电池容量8000mAh，加密通信，CAT6标准',

    // 招聘信息
    Linux_Software_Engineer: 'Linux软件工程师',
    Job_requirements: '任职要求：',
    Linux_p1: '计算机科学与技术、自动化、电子信息工程等相关专业本科以上学历；',
    Linux_p2: '熟练掌握ARM/MIPS等架构，Linux系统上的应用程序开发，有串口，SOCKET，视音频开发经验者优先；',
    Linux_p3: '有高通，MTK，展锐平台4G，5G开发经验的工程师优先；有Rockchip平台平板开发经验的工程师优先；',
    Linux_p4: '具备较强的团队协作能力、沟通能力、责任意识及上进心；具有较为开放的思维，良好的学习和承压能力；',
    Linux_p5: '欢迎应届毕业生和实习生。',

    Android_Developer: '安卓开发工程师',
    Android_p1: '计算机相关专业，本科及以上学历，两年及以上Android研发工作经验；',
    Android_p2: '熟悉安卓常用APP开发：摄像头，蓝牙，串口，JNI等；',
    Android_p3: '熟悉HTTP，TELNET等通信协议及原理，能熟练开发SOCKET应用；',
    Android_p4: '具有嵌入式产品应用程序、UI开发经验者优先；',
    Android_p5: '具备较强的语言表达能力、沟通能力和组织能力，具备良好的团队协作精神和独立解决问题的能力。',

    Machine_test_engineer: '整机测试工程师',
    Test_p1: '参与产品功能的测试及分析，发现测试分析中的问题，评估项目的风险，和同事配合确保产品按时转产；',
    Test_p2: '参与测试技术方案的设计、攻坚及实施落地，包括但不限于自动化测试、持续集成、性能测试等领域；',
    Test_p3: '测试过程中，主动总结，及时反馈暴露过程中的问题，并尝试改进测试方法和优化过程；',
    Test_p4: '参与测试团队技术分享；',

    Resume_delivery: '简历投递邮箱地址：',

    // LC800
    Lc800_p1: 'LC800型PDA是一款手持式维护终端，针对国内外电信运营商全网运营需求而推出的一款集工业电脑、'+
    '光功率、三千兆(5G,LAN,WIFI-6)、红光源、HDMI电视仿真等众多功能于一身的智能综合测试产品。',
    Lc800_Interface_p1: '双千兆,HDMI输入,Type-C USB,xGPON激光',
    Lc800_Interface_p2: '红光源，NFC，摄像头',
    Lc800_p_word: '5.5寸，1080P分辨率，电池容量8000mAh，支持5G和WIFI-6，支持三千兆测速',

    Product_performance: '产品详情',
    Serial_number: '序号',
    project: '项目',
    describe: '描述',
    td2_1: '三千兆网络',
    td2_2: '操作系统',
    td2_3: '存储',
    td2_4: '屏幕',
    td2_5: '摄像头',
    td2_6: 'NFC身份证阅读',
    td2_7: '激光线路测量',
    td2_8: 'GPS，蓝牙',
    td2_9: 'HDMI电视仿真',
    td2_10: 'IPTV/OTT测量',
    td2_11: '电池容量',
    td2_12: '接口',
    td2_13: '尺寸',

    td3_1: '蜂窝千兆：5G，支持NSA/SA',
    td3_2: '有线千兆：2路，支持端口镜像',
    td3_3: '无线千兆：WIFI-6，支持MU-MIMO',
    td3_4: '安卓',
    td3_5: '标配：3+32GB',
    td3_6: '选配：4+64GB和更高',
    td3_7: '5.5寸，全高清，触摸',
    td3_8: '支持',
    td3_10: '1G，10G功率测量，VFL测量，ONU开通，PPPoE等',
    td3_12: '支持4K输入，支持H.265码流录制',
    td3_14: '聚合物锂电池，8000mAh',
    td3_15: 'RJ45：x2',
    td3_16: '光纤口：FC/SC x2',
    td3_17: 'SIM卡：x1',
    td3_18: 'TF卡：x1',
    td3_19: 'HDMI：x1',
    td3_20: 'Type-C USB：x1',
    td3_21: '160*80*25mm',
    
}
